import {add} from "date-fns";

// Return the date for which we have available pricing data in BigData API - value from API or current date.
export const getPricesAvailableDate = (apiPricesAvailableDate?: string) => {
    // For date from API we need to add one month
    return apiPricesAvailableDate ? add(apiPricesAvailableDate, {months: 1}) : new Date();
};
